// THE DIGEST IS READY (Stage 4.6c, the owner's decision 1): a calm line at the top of the Dashboard while the newest weekly digest is
// unread — Open takes the owner to Analytics → Weekly digest; the cross marks it read. Nothing for an agent or when all is read.
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { Sparkles, X } from "lucide-react";

import { dayText } from "../../../../utils/times";
import { getDigests, markDigestRead } from "./insightsApi";
import { giveTabHint } from "./digestMeta";

export default function DigestBanner({ onNavigate }) {
  const { t } = useTranslation("insights");
  const [d, setD] = useState(null);
  useEffect(() => {
    let alive = true;
    getDigests().then((v) => { const top = v.digests?.[0]; if (alive && top && !top.readAt) setD(top); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!d) return null;
  const open = () => { giveTabHint("digest"); onNavigate?.("analytics"); };
  const dismiss = () => { markDigestRead(d.id).catch(() => {}); setD(null); };
  return (
    <Box role="status" sx={{ display: "flex", alignItems: "center", gap: "var(--sp-3)", p: "var(--sp-3)", mb: "var(--sp-4)", borderRadius: "var(--r-lg)",
      border: "1px solid var(--line-100)", bgcolor: "var(--c-violet-bg)" }}>
      <Sparkles size={18} aria-hidden="true" color="var(--c-violet)" />
      <Typography sx={{ fontFamily: "var(--font-ui)", fontSize: "var(--t-body-sm)", color: "var(--ink-900)", flex: 1 }}>
        {t("digest.banner", { range: `${dayText(d.weekStart)} – ${dayText(d.weekEnd)}` })}
      </Typography>
      <Button size="small" variant="contained" onClick={open} sx={{ textTransform: "none", minHeight: 36 }}>{t("digest.open")}</Button>
      <IconButton size="small" onClick={dismiss} aria-label={t("digest.dismiss")} sx={{ width: 36, height: 36 }}><X size={16} /></IconButton>
    </Box>
  );
}
